export default __webpack_public_path__ + "static/media/request-render-trimmed-linux.14ce931d.avif";